import { Components } from '@mui/material/styles'

export const MuiAccordionDetails: Components['MuiAccordionDetails'] = {
  styleOverrides: {
    root: {
      padding: '0',
    },
  },
}
